import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import { Components, Utils, translate } from 'versafleet-core';
import GlobalSearchDropdown from './dropdown';

class GlobalSearchContent extends React.Component {
  constructor(props) {
    super(props);
    this.nodeRef = React.createRef();
  }

  _renderCloseButton() {
    if (this.props.isOpened && Utils.Helper.isNonEmptyString(this.props.value)) {
      return (
        <div
          className="vf-global-search__content__close-button"
          onClick={() => this.props.onChange()}
        >
          <i className="versa-close" />
        </div>
      );
    }
    return false;
  }

  _renderDropdown() {
    if (this.props.isOpened && Utils.Helper.isNonEmptyString(this.props.value)) {
      return (
        <GlobalSearchDropdown
          isLoading={this.props.isLoading}
          jobs={this.props.jobs}
          onClickItem={this.props.onClickItem}
          tasks={this.props.tasks}
        />
      );
    }
    return false;
  }

  _renderTextbox() {
    return (
      <CSSTransition
        classNames="vf-global-search__content"
        in={this.props.isOpened}
        nodeRef={this.nodeRef}
        timeout={{ enter: 250, exit: 50 }}
        unmountOnExit
      >
        <div ref={this.nodeRef}>
          <Components.Input.Textbox
            className="vf-global-search__content__textbox"
            onChange={val => this.props.onChange(val)}
            placeholder={this.props.strings.inputHint}
            value={this.props.value}
          />
        </div>
      </CSSTransition>
    );
  }

  render() {
    return (
      <div className="vf-global-search__content">
        {this._renderTextbox()}
        {this._renderCloseButton()}
        {this._renderDropdown()}
      </div>
    );
  }
}

GlobalSearchContent.displayName = 'Global Search Content';

GlobalSearchContent.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isOpened: PropTypes.bool.isRequired,
  jobs: PropTypes.arrayOf(PropTypes.shape()),
  onChange: PropTypes.func.isRequired,
  onClickItem: PropTypes.func.isRequired,
  strings: PropTypes.shape().isRequired,
  tasks: PropTypes.arrayOf(PropTypes.shape()),
  value: PropTypes.string,
};

GlobalSearchContent.defaultProps = {
  jobs: [],
  tasks: [],
  value: null,
};

export default translate('GlobalSearch')(GlobalSearchContent);
